// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"4f1645c1","341":"19838571","377":"bee30ea2","631":"77fcf074","734":"a25a9320","912":"05c134c2"}[chunkId] + ".chunk.js";
};